/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component,
    ComponentFactoryResolver,
    Injector, Type,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import $ from 'jquery';
import {Observable} from 'rxjs';
import {FcAgContextComponent} from './fc-ag-context.component';

/**
 * Fc Context component with Angular.
 */
@Component({
    selector: 'fc-ag-context-holder',
    templateUrl: './fc-ag-context-holder.component.html',
    styleUrls: ['./fc-ag-context-holder.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcAgContextHolderComponent {
    
    /**
     * Target viewContainer to insert modals.
     */
    @ViewChild('viewContainer', {read: ViewContainerRef, static: true}) viewContainer : any;

    /**
     * Top position of wrapper.
     */
    topPos: string;

    /**
     * Is context showing.
     */
    isShowing: boolean = false;

    /**
     * Right position of wrapper.
     */
    rightPos: string;
    
    /**
     * Component constructor.
     *
     * @param resolver ComponentFactoryResolver.
     * 
     * FcAgContextComponent constructor.
     */
    constructor(private resolver: ComponentFactoryResolver) {
    }

    /**
     * Configures then adds modal to the modals array, and populates with data passed in.
     *
     * @param component Component instance.
     * @param event Click Event.
     * @param data Extend component data.
     * @returns Observable.
     */
    addModal(component: Type<FcAgContextComponent>, event: any, data: any): Observable<any> {
        this.isShowing = true;
        
        const target:any = $(event.currentTarget);
        const windowElm:any = $(window);

        const offset:any = target.offset();
        this.topPos = (offset.top - windowElm.scrollTop()) + 'px';
        this.rightPos = (windowElm.width() - offset.left + 10) + 'px';

        const factory = this.resolver.resolveComponentFactory(component);
        const injector = Injector.create({
            providers: [],
            parent: this.viewContainer.injector
        });
        const componentRef = factory.create(injector);
        this.viewContainer.insert(componentRef.hostView);
        
        let content:FcAgContextComponent = componentRef.instance;
        
        content.onClosing(() => this.removeModal());
        content.mapDataObject(data);
        
        return content.setupObserver();
    }
    
    /**
     * Remove context instance.
     */
    removeModal(): void {
        this.isShowing = false;
        this.viewContainer.remove(0);
    }
}
